import {
  HomeIcon,
  BookOpenIcon,
  ClipboardDocumentIcon,
  KeyIcon,
  Cog6ToothIcon,
  PresentationChartBarIcon,
} from '@heroicons/react/24/solid';
import Routes from '@/router/Routes.ts';

export type NavItem = {
  title: string;
  path: string;
  icon: JSX.Element;
  tooltipTitle?: string;
};

export const navData: NavItem[] = [
  {
    title: 'Dashboard',
    path: Routes.DASHBOARD,
    icon: <HomeIcon />,
  },
  {
    title: 'Practice Area',
    path: Routes.PRACTICE_AREA,
    icon: <BookOpenIcon />,
    tooltipTitle: 'Practice each question type, one by one',
  },
  {
    title: 'Sit a Past Paper',
    path: Routes.FULL_PAST_PAPERS,
    icon: <ClipboardDocumentIcon />,
    tooltipTitle: 'Select a past paper to complete under exam conditions and receive feedback',
  },
  // {
  //   title: 'AI Feedback & Targeted Quizzes',
  //   path: Routes.AI_FEEDBACK_QUIZZES,
  //   icon: <SparklesIcon />,
  //       tooltipTitle: 'Practice each question type, one by one',
  // },
  // {
  //   title: 'Learning Bank',
  //   path: Routes.LEARNING_BANK,
  //   icon: <BuildingLibraryIcon />,
  //   tooltipTitle: 'Resources and mini topic quizzes to develop skills needed for this exam paper',
  // },
  {
    title: 'Download Past Papers',
    path: Routes.DOWNLOAD_PAST_PAPERS,
    icon: <KeyIcon />,
    tooltipTitle: 'Download a past paper to view or print',
  },
  {
    title: 'Progress Tracker',
    path: Routes.PROGRESS_TRACKER,
    icon: <PresentationChartBarIcon />,
    tooltipTitle: 'Completed papers, current grade, historic papers, grades and feedback',
  },
  {
    title: 'Account Settings',
    path: Routes.ACCOUNT_SETTINGS,
    icon: <Cog6ToothIcon />,
  },
];
